module.exports = __webpack_public_path__ + "92467d3c85cc45c861e88b8de09d5b67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/thrift_savings_plan_2022_chart.png
// module id = 1745
// module chunks = 0